import React from "react";
import Theme from "../../Theme/Theme";
import styled from "styled-components";
import { Outlet } from "react-router";

export default function PageInfo() {
  return (
    <Container>
      <Outlet />
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 76vh;
  background-color: ${Theme.colorBackgroundBox};
  border-radius: ${Theme.borderRadius};
  box-sizing: border-box;
  padding-bottom: 15px;
  margin: 15px 0 0;
  margin-bottom: 15px;
  z-index: 1;
`;
